/**
 * Render NotificationsContainer once in the app layout; NotificationsService supplies the
 * add(message, options) API.
 */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import ToastContainer from './toast';
import type NotificationsServiceClass from '../services/notifications.ts';

// Re-export the service type for consumers
export type NotificationsService = NotificationsServiceClass;

interface NotificationsContainerSignature {
  Args: {
    /**
     * Placement of the container. Currently always renders bottom-right
     * (reimagined design), this prop exists only for @frontile compat.
     */
    placement?: string;
  };
  Element: HTMLDivElement;
}

/**
 * Drop-in replacement for `<NotificationsContainer>` from tio-ui/notifications.
 *
 * Renders the reimagined Toast stack, auto-wired to the `notifications` service.
 * Place once in your application template.
 */
export class NotificationsContainer extends Component<NotificationsContainerSignature> {
  @service declare notifications: NotificationsServiceClass;

  dismiss = (id: string) => {
    this.notifications.dismiss(id);
  };

  <template>
    <ToastContainer
      @toasts={{this.notifications.toasts}}
      @onDismiss={{this.dismiss}}
      ...attributes
    />
  </template>
}

export default NotificationsContainer;
